<div
  class="relative md:pt-32 pb-32 pt-12 mb-36 bg-cover bg-center"
  style="background-image: url('assets/img/background.jpg')"
>
  <div class="mx-auto w-full px-4 md:px-10">
    <div>
      <div *ngIf="loading" class="flex flex-wrap">
        <div class="w-full px-4 py-8 text-center text-sm text-white/90">
          Carregando indicadores…
        </div>
      </div>

      <div *ngIf="error && !loading" class="flex flex-wrap">
        <div class="w-full rounded bg-black/30 px-4 py-3 text-sm text-white backdrop-blur-sm">
          {{ error }}
        </div>
      </div>

      <div *ngIf="analytics && !loading" class="flex flex-wrap">
        <div class="w-full px-4 lg:w-6/12 xl:w-3/12">
          <app-card-stats
            statSubtitle="Total de Vendas"
            [statTitle]="formatSales(analytics.kpis.total_sales_brl.value)"
            [statArrow]="analytics.kpis.total_sales_brl.change_percent >= 0 ? 'up' : 'down'"
            [statPercent]="formatDelta(analytics.kpis.total_sales_brl.change_percent)"
            [statPercentColor]="
              analytics.kpis.total_sales_brl.change_percent > 0
                ? 'text-emerald-500'
                : analytics.kpis.total_sales_brl.change_percent < 0
                  ? 'text-red-500'
                  : 'text-blueGray-400'
            "
            [statDescripiron]="analytics.kpis.total_sales_brl.comparison"
            statIconName="heroChartBar"
            statIconColor="bg-red-500"
          ></app-card-stats>
        </div>
        <div class="w-full px-4 lg:w-6/12 xl:w-3/12">
          <app-card-stats
            statSubtitle="Total de Empresas"
            [statTitle]="formatInteger(analytics.kpis.total_companies.value)"
            [statArrow]="analytics.kpis.total_companies.change_percent >= 0 ? 'up' : 'down'"
            [statPercent]="formatDelta(analytics.kpis.total_companies.change_percent)"
            [statPercentColor]="
              analytics.kpis.total_companies.change_percent > 0
                ? 'text-emerald-500'
                : analytics.kpis.total_companies.change_percent < 0
                  ? 'text-red-500'
                  : 'text-blueGray-400'
            "
            [statDescripiron]="analytics.kpis.total_companies.comparison"
            statIconName="heroChartPie"
            statIconColor="bg-orange-500"
          ></app-card-stats>
        </div>
        <div class="w-full px-4 lg:w-6/12 xl:w-3/12">
          <app-card-stats
            statSubtitle="Membros Afiliados"
            [statTitle]="formatInteger(analytics.kpis.affiliate_members.value)"
            [statArrow]="analytics.kpis.affiliate_members.change_percent >= 0 ? 'up' : 'down'"
            [statPercent]="formatDelta(analytics.kpis.affiliate_members.change_percent)"
            [statPercentColor]="
              analytics.kpis.affiliate_members.change_percent > 0
                ? 'text-emerald-500'
                : analytics.kpis.affiliate_members.change_percent < 0
                  ? 'text-red-500'
                  : 'text-blueGray-400'
            "
            [statDescripiron]="analytics.kpis.affiliate_members.comparison"
            statIconName="heroUserGroup"
            statIconColor="bg-pink-500"
          ></app-card-stats>
        </div>
        <div class="w-full px-4 lg:w-6/12 xl:w-3/12">
          <app-card-stats
            statSubtitle="Eventos Realizados"
            [statTitle]="formatInteger(analytics.kpis.events_held.value)"
            [statArrow]="analytics.kpis.events_held.change_percent >= 0 ? 'up' : 'down'"
            [statPercent]="formatDelta(analytics.kpis.events_held.change_percent)"
            [statPercentColor]="
              analytics.kpis.events_held.change_percent > 0
                ? 'text-emerald-500'
                : analytics.kpis.events_held.change_percent < 0
                  ? 'text-red-500'
                  : 'text-blueGray-400'
            "
            [statDescripiron]="analytics.kpis.events_held.comparison"
            statIconName="heroCalendarDays"
            statIconColor="bg-emerald-500"
          ></app-card-stats>
        </div>
      </div>
    </div>
  </div>
</div>
